import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '@/components/ui/card';
import { EnhancedAchievements } from '@/components/dashboard/EnhancedAchievements';
import { useNavigate } from 'react-router-dom';

export function AchievementsPage() {
  const navigate = useNavigate();

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="container mx-auto py-8 space-y-8"
    >
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">Your Achievements</h1>
        <button 
          onClick={() => navigate('/dashboard')}
          className="px-4 py-2 text-sm bg-primary-600 text-white rounded-lg hover:bg-primary-700"
        >
          Back to Dashboard
        </button>
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <Card className="p-6">
          <EnhancedAchievements progress={null} />
        </Card>
        
        <div className="space-y-6">
          <Card className="p-6">
            <h2 className="text-xl font-semibold mb-4">Achievement Stats</h2>
            <div className="grid grid-cols-2 gap-4">
              <div className="p-4 bg-primary-50 rounded-lg">
                <p className="text-sm text-primary-600">Total Achievements</p>
                <p className="text-2xl font-bold text-primary-700">10</p>
              </div>
              <div className="p-4 bg-green-50 rounded-lg">
                <p className="text-sm text-green-600">Completed</p>
                <p className="text-2xl font-bold text-green-700">3</p>
              </div>
            </div>
          </Card>

          <Card className="p-6">
            <h2 className="text-xl font-semibold mb-4">Recent Unlocks</h2>
            {/* We'll use the existing AchievementsPanel component here */}
          </Card>
        </div>
      </div>
    </motion.div>
  );
} 